import * as jsxRuntime from "/home/documaster-albert-gui-1.19.0-1release88354-fe74c618a98f/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment